import { Grid, Typography } from '@mui/material'

const AddressDetails = ({ title, value }: { title?: string, value: string }) => (
  <Grid container>
    <Grid item xs={12} >
      { title && <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
        {title}
      </Typography>}
      <Typography variant="body1">
        {value}
      </Typography>
    </Grid>
  </Grid>
)

export default AddressDetails